import { render, staticRenderFns } from "./UserAreaList.vue?vue&type=template&id=07880a8c&scoped=true&"
import script from "./UserAreaList.vue?vue&type=script&lang=js&"
export * from "./UserAreaList.vue?vue&type=script&lang=js&"
import style0 from "./UserAreaList.vue?vue&type=style&index=0&id=07880a8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07880a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07880a8c')) {
      api.createRecord('07880a8c', component.options)
    } else {
      api.reload('07880a8c', component.options)
    }
    module.hot.accept("./UserAreaList.vue?vue&type=template&id=07880a8c&scoped=true&", function () {
      api.rerender('07880a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/UserAreaList.vue"
export default component.exports